module.exports = __webpack_public_path__ + "img/background.b7599d48.svg";